// extracted by mini-css-extract-plugin
module.exports = {"card":"index__card___35GxF typography__bodyFont___1exgA","section":"index__section___106Oq","heading":"index__heading___3RE8g"};